import { deleteItem } from "./productsCart";

window.addEventListener("load", () => {
  const formElement = document.querySelector(".populate-posts");
  const productActionElements = document.querySelectorAll(
    ".product-chooser .product",
  );
  const addressElement = document.querySelector(".populate-address");
  if (formElement && productActionElements) {
    handleForm(formElement, productActionElements);
  }
  if (addressElement) {
    window.addEventListener("soilfood-address-change", () =>
      handlePrefillAddress(addressElement),
    );
    handlePrefillAddress(addressElement);
  }
  if (document.querySelector(".gform_confirmation_message")) {
    document.querySelector(".product-chooser").remove();
  }
});

/**
 * @param {Element} formEl
 * @param {any[] | NodeListOf<Element>} products
 */
const handleForm = (formEl, products) => {
  products.forEach((el) => {
    el.querySelector("[data-product-name]").addEventListener("click", () => {
      handleClick(el, formEl);
    });
  });
};

/**
 * @param {Element} el
 * @param {Element} formEl
 */
const handleClick = (el, formEl) => {
  const product = el
    .querySelector("[data-product-name]")
    .getAttribute("data-product-name");
  const productId = el
    .querySelector("[data-product-name]")
    .getAttribute("data-product-id");
  formEl.querySelectorAll(":checked").forEach((option) => {
    if (option.value === product) {
      option.selected = false;
      jQuery(document).trigger("gform_post_render", [
        formEl.closest("form").getAttribute("id").replace("gform_", ""),
      ]);
      el.remove();
      deleteItem(productId);
    }
  });
};

const handlePrefillAddress = (addressElement) => {
  const input = addressElement.querySelector("input");
  const store = JSON.parse(sessionStorage.getItem("soilfood_store"));
  if (
    store &&
    store.address_info &&
    store.address_info.addressLine &&
    store.address_info.addressLine.length > 0
  )
    input.value = store.address_info.addressLine;
};
